import axios, {AxiosResponse, CancelToken} from 'axios';
import {CANCEL} from 'redux-saga';

import Url from '../constants/Url';

class MyTop10GamesApi {
    getMyTop10Games({value, ...params}) {
        const source = axios.CancelToken.source();
        const cancelToken: CancelToken = source.token;

        const request: Promise<AxiosResponse<string>> = axios
            .get(Url().GET_TOP_10_GAMES(value), {params, cancelToken})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to getMyTop10Games:', ex.message);
                throw ex;
            });

        request[CANCEL] = () => source.cancel();

        return request;
    }
}

export default new MyTop10GamesApi();
